// 全局getters函数 返回你想要的全局状态格式
// https://vuex.vuejs.org/zh/guide/getters.html
export default {
  token: state => state.app.token,
  transitionName: state => state.app.transitionName,
  loginConfig: state => state.app.loginConfig,
  tripType: state => state.app.tripType,
  serviceCtrl: state => state.app.serviceCtrl,
  orderListParams: state => state.app.orderListParams,
  sysType: state => state.app.sysType,
  loginNotices: state => state.app.loginNotices,
  badgeDotCount: state => state.app.badgeDotCount
}
